<template>
  <input
      class="form-control"
      v-bind="{
      ...$attrs,
      onInput: updateValue
    }"
      :id="uuid"
      :value="modelValue"
      :placeholder="placeholder"
      :aria-describedby="error ? `${uuid}-error` : null"
      :aria-invalid="error ? true : false"
      :class="{ error }"
  >
  <ErrorMessage
      v-if="error"
      :id="`${uuid}-error`"
  >
    {{ error }}
  </ErrorMessage>
</template>

<script>
import SetupFormComponent from '@/Lib/SetupFormComponent'
import UniqueID from '@/Lib/UniqueID'

export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [String, Number],
      default: ''
    }
  },
  setup (props, context) {
    const { updateValue } = SetupFormComponent(props, context)
    const uuid = UniqueID().getID()

    return {
      updateValue,
      uuid
    }
  }
}
</script>